import { formatFileSize, isDefinedGlobally } from './utils';

const messages = {
  _default: () => `Value is not valid.`,
  after: (field, [target, inclusion]) => `Must be after ${inclusion ? 'or equal to ' : ''}${target}.`,
  alpha_dash: () => `Field may contain alpha-numeric characters as well as dashes and underscores.`,
  alpha_num: () => `Field may only contain alpha-numeric characters.`,
  alpha_spaces: () => `Field may only contain alphabetic characters as well as spaces.`,
  alpha: () => `Field may only contain alphabetic characters.`,
  before: (field, [target, inclusion]) => `Must be before ${inclusion ? 'or equal to ' : ''}${target}.`,
  between: (field, [min, max]) => `Field must be between ${min} and ${max}.`,
  confirmed: () => `Confirmation does not match.`,
  credit_card: () => `Field is invalid.`,
  date_between: (field, [min, max]) => `Must be between ${min} and ${max}.`,
  date_format: (field, [format]) => `Must be in the format ${format}.`,
  decimal: (field, [decimals = '*'] = []) => `Field must be numeric and may contain ${!decimals || decimals === '*' ? '' : decimals} decimal points.`,
  digits: (field, [length]) => `Field must be numeric and exactly contain ${length} digits.`,
  dimensions: (field, [width, height]) => `Field must be ${width} pixels by ${height} pixels.`,
  email: () => `Field must be a valid email.`,
  ext: () => `Field must be a valid file.`,
  image: () => `Field must be an image.`,
  included: () => `Field must be a valid value.`,
  integer: () => `Field must be an integer.`,
  ip: () => `Field must be a valid ip address.`,
  length: (field, [length, max]) => {
    if (max) {
      return `Length must be between ${length} and ${max}.`;
    }
    return `Length must be ${length}.`;
  },
  max: (field, [length]) => `Field may not be greater than ${length} characters.`,
  max_value: (field, [max]) => `Field must be ${max} or less.`,
  mimes: () => `Field must have a valid file type.`,
  min: (field, [length]) => `Field must be at least ${length} characters.`,
  min_value: (field, [min]) => `Field must be ${min} or more.`,
  excluded: () => `Field must be a valid value.`,
  numeric: () => `Field may only contain numeric characters.`,
  regex: () => `Field format is invalid.`,
  required: () => `Field is required.`,
  size: (field, [size]) => `Size must be less than ${formatFileSize(size)}.`,
  url: () => `Field is not a valid URL.`
};

const locale = {
  name: 'en',
  messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize({ [locale.name]: locale });
}

export default locale;